<template>
    <div class="content-wapper">
        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">NQI服务</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/zltszhfw/jlfw' }">计量服务</el-breadcrumb-item>
                    <el-breadcrumb-item>威海市计量授权机构查询</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>


        <el-row style="background-color: #FCFCFC;">

            <el-row class="right-box-row" style="min-height: 430px;">

                <el-row class="right-box-row-title">
                    威海市计量授权机构查询
                </el-row>

                <el-row>
                    <el-form :model="queryParams" ref="queryParams" :inline="true" label-width="140px">
                        <el-col :span="8">
                            <el-form-item label="机构名称：" prop="mechanismName">
                                <el-input
                                        v-model="queryParams.mechanismName"
                                        placeholder="请输入机构名称"
                                        clearable
                                        size="small"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="地址：" prop="dom">
                                <el-input
                                        v-model="queryParams.dom"
                                        placeholder="请输入地址"
                                        clearable
                                        size="small"
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="3">
                            <el-form-item>
                                <el-button type="primary" icon="el-icon-search" size="mini" @click="getList" style="margin-right: 20px">检 索</el-button>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-row>

                <el-table v-loading="loading" :data="list"  tooltip-effect="light" :header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
                    <el-table-column label="机构名称" align="center" prop="mechanismName" 
					 width="400"/>
                    <el-table-column label="地址" align="center" prop="dom" 
					 width="80"/>
                    <el-table-column label="联系电话" align="center" prop="tel" width="80">
                        <template slot-scope="scope">
                            <el-tag v-if="!isLoginState">登录后查看</el-tag>
                            <span v-if="isLoginState" >{{scope.row.tel}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="授权证书编号" align="center" prop="authorizationCode" 
					 width="80"/>
                    <el-table-column label="有效日期" align="center" prop="effectiveDate" 
						width="80">
                        <template slot-scope="scope">
                            <span>{{ parseTime(scope.row.effectiveDate, '{y}-{m}-{d}') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="机构等级" align="center" prop="organLevel" width="80"/>
                    <el-table-column label="授权区域" align="center" prop="mechanismRegion" width="80"/>
                </el-table>
                <pagination
                        v-show="total>0"
                        :total="total"
                        :page.sync="queryParams.pageNum"
                        :limit.sync="queryParams.pageSize"
                        @pagination="getList"
                />
            </el-row>
        </el-row>
    </div>
</template>

<script>
    import { listJljgxx, } from "@/api/zlts/jlfw/jljgxx";
    export default {
        name: "MainWhsjlsqjgcx",
        data() {
            return {
                // 遮罩层
                loading: false,
                // 总条数
                total: 0,
                list:[],
                queryParams:{
                    pageNum:1,
                    pageSize:10,
                    mechanismName: undefined,
                    dom: undefined,
                },
                isLoginState:undefined,
            }
        },
        created() {
            this.getList()
        },
        methods:{
            openPage(url){
                this.utils.windowOpen(url);
            },
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh(){
                this.getList();
            },
            getList() {
				//----【】需要修改为recid
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if (ssessionLoginUser != null && ssessionLoginUser.islogin) {
					this.isLoginState = true;
				} else {
					this.isLoginState = false;
				}
                this.loading = true;
                listJljgxx(this.queryParams).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.loading = false;
                });
                
            },
            openDetail(item){
                // this.$router.push({
                // 	path: '/main/zscqzhfw/flfgzc/detail/'+item.recid
                // })
                // this.$store.commit('SET_MAININDEX', '/main/zscqzhfw/flfgzc');
            }
        }
    }
</script>

<style scoped="scoped">
    .content-wapper{
        margin-top: 5px;
        padding: 10px;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .search-select .el-button{
        background-color: #fcfcfc;
    }
    .search-where{
        margin: 10px 0px;
        padding: 15px;
    }
    .el-divider--horizontal{
        margin: 12px 0px;
    }
    .el-button{
        border: 0px;
    }
    .el-range-editor.el-input__inner{
        padding: 5px 10px;
    }
    .el-range-editor--medium.el-input__inner{
        height: 40px;
    }

    .right-box-row{
        border: 1px solid #cccccc;
        padding: 10px 15px 0;
    }
    .search-page{
        padding: 20px 0px;
        background-color: #ffffff;
        display: flex;
    }
    .order-filed{
        padding: 0px 30px;
        color:#000000;
        border-bottom: 1px solid #cccccc;
    }
    .font-warning{
        color: #e6a23c;
    }
    .search-page .el-button+.el-button{
        margin-left: 0;
    }
    .search-page .el-button--medium{
        border-radius: 0;
    }
    /deep/.el-table__body-wrapper .title:hover{
        color: #1482f0;
        cursor: pointer;
    }

    .right-box-row-title{
        padding: 15px 0;
        text-align: left;
        color: #1c84c6;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid #cccccc;
        margin-bottom: 20px;
    }
</style>
